import script from "./ServicesIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServicesIcon.vue?vue&type=script&setup=true&lang=ts"

import "./ServicesIcon.vue?vue&type=style&index=0&id=6ea44afa&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ea44afa"]])

export default __exports__